import "../../../../../js/organism/carousel/topics";
import "../../../../../js/atoms/toggle/translate-contents";

import { SettingsUpdater } from "../../../../../js/molecules/settingsUpdater";

SettingsUpdater(".js-save-topics-order");
SettingsUpdater(".js-save-topics-order-mobile", { eventName: "change" });
